import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import { WebView } from '@zenbusiness/application-commons-webview';
import Empty from '@zenbusiness/zui/Empty';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './AppFooter.style';
import CookiePreferences from './CookiePreferences';
import { DisclosureText } from './DisclosureText';

const EMOJI_LIST = ['🐐', '🌮', '❤️'];
const madeWithEmoji = EMOJI_LIST[Math.floor(Math.random() * EMOJI_LIST.length)];
const releaseYear = new Date().getFullYear();

function AppFooter() {
  if (WebView.isWebView) {
    return <Empty />;
  }

  return (
    <Styled.Root>
      <DisclosureText />

      <Text
        color="tertiary"
        size="sm"
      >
        <FormattedMessage id="dashboard.footer.label" values={{ madeWithEmoji, releaseYear }} />
        <CookiePreferences />
      </Text>
    </Styled.Root>
  );
}

export default AppFooter;
